import React, { useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactImageFallback from "react-image-fallback";

const TicketModal = ({ show, handleClose, response }) => {
  const printTicket = (printModal) => {
    var divContents = document.getElementById("printModal").innerHTML;
    var a = window.open("", "", "height=900, width=900");
    a.document.write(
      `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css" integrity="sha384-zCbKRCUGaJDkqS1kPbPd7TveP5iyJE0EjAuZQTgFLD2ylzuqKfdKlfG/eSrtxUkn" crossorigin="anonymous"> `
    );
    a.document.write(divContents);
    a.print();
  };
  // const PrintWebTicket = (traceId) => {
  //   window.open(
  //     "http://testapi.need82dot.com/api/v1/flight/print-ticket/" + traceId
  //   );
  // };
  console.log(response);
  return (
    <Fragment>
      <Modal show={show} size="lg" scrollable={true}>
        <Modal.Header>
          <Modal.Title>Ticket Print</Modal.Title>
          <button
            id="printBtn"
            className="btn btn-primary"
            // onClick={() => PrintWebTicket(response?.response?.traceId)}
          >
            Print
          </button>
        </Modal.Header>
        <Modal.Body>
          {response !== null ? (
            Object.keys(response).length !== 0 && (
              <div>
                <div
                  className="mainContainer-modal container-fluid  p-3"
                  id="printModal"
                >
                  <div className="row pt-2 border ticket-header">
                    <div className="col-3">
                      <ReactImageFallback
                        className="ticket-image"
                        src={`/assets/images/AirlineLogo/${response?.response?.flightItinerary?.airlineCode}.gif`}
                        fallbackImage="/assets/images/AirlineLogo/no-image.png"
                      />{" "}
                      <span className="lead">
                        {
                          response.response?.flightItinerary?.segments[0]
                            .airline?.airlineName
                        }
                      </span>
                    </div>
                    <div className="col-4">
                      <p>
                        Invoice No-
                        {response.response?.flightItinerary?.invoiceNo}
                      </p>
                    </div>

                    <div className="col-5">
                      <p>
                        Invoice Date :{" "}
                        {response.response?.flightItinerary?.invoiceCreatedOn}
                      </p>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-12">
                      <table className="table table-striped border table-inverse">
                        <thead className="thead-inverse text-primary">
                          <tr>
                            <th> PNR/Booking Reference</th>
                            <th>Booking Id</th>
                            <th>Departure Date</th>
                            <th>Arrival Date</th>
                            <th>Departure Time</th>
                            <th>Arrival Time</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          <tr>
                            <td>{response.response?.flightItinerary?.pnr}</td>
                            <td>
                              {response.response?.flightItinerary?.bookingId}
                            </td>
                            <td>
                              {
                                response.response?.flightItinerary?.segments[0].origin?.depTime.split(
                                  "T"
                                )[0]
                              }
                            </td>
                            <td>
                              {
                                response.response?.flightItinerary?.segments[
                                  response.response?.flightItinerary?.segments
                                    .length - 1
                                ]?.destination?.arrTime.split("T")[0]
                              }
                            </td>
                            <td>
                              {
                                response.response?.flightItinerary?.segments[0]?.origin.depTime.split(
                                  "T"
                                )[1]
                              }
                            </td>
                            <td>
                              {
                                response.response?.flightItinerary?.segments[
                                  response.response?.flightItinerary?.segments
                                    .length - 1
                                ]?.destination?.arrTime.split("T")[1]
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="col-12 mt-2">
                      <div className="details-heading">
                        <p className="bg-primary text-white text-center rounded">
                          Passenger Details
                        </p>
                      </div>
                      <table className="table table-striped border table-inverse">
                        <thead className="thead-inverse text-primary">
                          <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>Contact No</th>
                            <th>Email</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {response.response?.flightItinerary?.passenger.map(
                            (person, index) => (
                              <tr key={index}>
                                <td>{person?.firstName}</td>
                                <td>{person?.lastName}</td>
                                <td>{person?.addressLine1}</td>
                                <td>{person?.city}</td>
                                <td>{person?.contactNo}</td>
                                <td>{person?.email}</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-12 mt-3">
                      <div className="details-heading">
                        <p className="bg-primary text-white text-center rounded">
                          Flight Details
                        </p>
                      </div>
                      <table className="table table-striped table-inverse border">
                        <thead className="thead-inverse">
                          <tr className="text-primary">
                            <th>Flight</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Dep Time</th>
                            <th>Arr Time</th>
                            <th>Baggage / Cabin Baggage</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {response.response?.flightItinerary?.segments.map(
                            (flight, index) => (
                              <tr key={index}>
                                <td>
                                  {flight?.airline?.airlineName}{" "}
                                  {flight?.airline?.airlineCode}-
                                  {flight?.airline?.flightNumber}
                                </td>
                                <td>
                                  {flight.origin?.airport?.airportName ===
                                  flight.origin.airport.cityName ? (
                                    flight.origin.airport.cityName
                                  ) : (
                                    <>
                                      {flight?.origin?.airport?.cityName} -{" "}
                                      {flight?.origin?.airport?.airportName}
                                    </>
                                  )}
                                </td>

                                <td>
                                  {flight?.destination?.airport?.airportName ===
                                  flight?.destination?.airport?.cityName ? (
                                    flight?.destination?.airport?.cityName
                                  ) : (
                                    <>
                                      {flight?.destination?.airport?.cityName} -{" "}
                                      {
                                        flight?.destination?.airport
                                          ?.airportName
                                      }
                                    </>
                                  )}
                                </td>
                                <td>{flight?.origin?.depTime.split("T")[1]}</td>
                                <td>
                                  {flight?.destination?.arrTime.split("T")[1]}
                                </td>
                                <td>
                                  {flight?.baggage}/{flight?.cabinBaggage}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="col-12">
                      <div className="Bookingnote">
                        <p className="text-danger">
                          *Booking Date eects in UTC (Coordinate Universal
                          Time), all other timings mentioned are as per local
                          time
                        </p>
                      </div>
                    </div>

                    {/* <div className="col-12 mt-2">
                        <div className="details-heading">
                          <p className="bg-primary text-white text-center rounded">
                            GST Information
                          </p>
                        </div>
                        <div className="card">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-3 text-primary">
                                GST Number:
                              </div>
                              <div className="col-2 ">
                                {
                                  response.response.flightItinerary.passenger[0]
                                    .gstNumber
                                }
                              </div>
                              <div className="col-1 border-left"></div>
                              <div className="col-3 text-primary">
                                GST Company Name:
                              </div>
                              <div className="col-2">
                                {
                                  response.response.flightItinerary.passenger[0]
                                    .gstCompanyName
                                }
                              </div>

                              <div className="col-3 text-primary">
                                GST Company Address:
                              </div>
                              <div className="col-2 ">
                                {
                                  response.response.flightItinerary.passenger[0]
                                    .gstCompanyAddress
                                }
                              </div>
                              <div className="col-1 border-left"></div>
                              <div className="col-3 text-primary ">
                                GST Company Contact No:
                              </div>
                              <div className="col-2">
                                {
                                  response.response.flightItinerary.passenger[0]
                                    .gstCompanyContactNumber
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    <div className="col-12 mt-3">
                      <div className="details-heading">
                        <p className="bg-primary text-white text-center rounded">
                          Fare Summery
                        </p>
                      </div>
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-6">Base Fare:</div>
                            <div className="col-6 text-right">
                              {
                                response.response?.flightItinerary?.fare
                                  ?.baseFare
                              }{" "}
                              {
                                response.response?.flightItinerary?.fare
                                  ?.currency
                              }
                            </div>

                            <div className="col-6">Tax:</div>

                            <div className="col-6 text-right">
                              {response.response?.flightItinerary?.fare.tax}{" "}
                              {
                                response.response?.flightItinerary?.fare
                                  .currency
                              }
                            </div>

                            <div className="col-6">Service Fee:</div>

                            <div className="col-6 text-right">
                              {
                                response.response?.flightItinerary?.fare
                                  .serviceFee
                              }{" "}
                              {
                                response.response?.flightItinerary?.fare
                                  ?.currency
                              }
                            </div>
                            <div className="col-12">
                              <hr />
                            </div>
                            <div className="col-6">Total</div>
                            <div className="col-6 text-right">
                              {response.response?.flightItinerary?.fare
                                ?.serviceFee *
                                1 +
                                response.response?.flightItinerary?.fare
                                  ?.baseFare *
                                  1 +
                                response.response?.flightItinerary?.fare?.tax *
                                  1}{" "}
                              {
                                response.response?.flightItinerary?.fare
                                  ?.currency
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <hr />
                      <div className="details-heading">
                        <p className="bg-primary text-white text-center rounded">
                          Note
                        </p>
                      </div>
                      <p>
                        Goods and Service Tax(GST) shall be levied at applicable
                        ates on all air transportation services provided by
                        Need82, except cases specially exempted unde law.
                        <br />
                        This is no a GST invoice. The GST invoice shallbe sen to
                        he email ddress in the name of the passenge,menioned in
                        his itinerary.In case of a bookin made by a GSTIN holde,
                        the GST invoice shall be sen in he name of he GSTIN
                        holder to the email address mentioned while providing he
                        GSTIN infomatio at the time of reservation.
                        <br />
                        Additionally,passengers may download he GST invoice
                        using their PNR numbr on the Need82 website
                        www.need82.in.
                        <br />
                        GS shall also be applicable on any specil services
                        requesed by the passenger at applicable rates.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : (
            <>
              <div className="container mt-5 p-3">
                <div className="alert alert-danger" role="alert">
                  <strong>error</strong>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default TicketModal;
